import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [perms, setPerms] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api
      .get("/auth/me")
      .then(({ data }) => {
        setUser(data.user);
        setPerms(data.permissions || []);
      })
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  }, []);

  const login = async (employee_id, password, portal = "staff") => {
    const { data } = await api.post("/auth/login", { employee_id, password, portal });
    localStorage.setItem("omi-portal", portal);
    if (data.mfa_required) return data;
    setUser(data.user);
    setPerms(data.permissions || []);
    return data;
  };

  const completeLogin = (data) => { setUser(data.user); setPerms(data.permissions || []); };

  useEffect(() => {
    if (!user) return undefined;
    const KEY = "omi-last-activity";
    localStorage.setItem(KEY, String(Date.now()));
    let lastWrite = 0;
    const bump = () => { const n = Date.now(); if (n - lastWrite > 5000) { lastWrite = n; localStorage.setItem(KEY, String(n)); } };
    const evs = ["mousemove", "keydown", "click", "touchstart", "scroll"];
    evs.forEach((e) => window.addEventListener(e, bump, { passive: true }));
    const t = setInterval(async () => {
      if (Date.now() - Number(localStorage.getItem(KEY) || Date.now()) > 30 * 60 * 1000) {
        try { await api.post("/auth/logout"); } catch (_) {}
        sessionStorage.setItem("omi-logout-reason", "You were signed out after 30 minutes of inactivity.");
        setUser(false); setPerms([]);
      }
    }, 30000);
    return () => { clearInterval(t); evs.forEach((e) => window.removeEventListener(e, bump)); };
  }, [user]);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (_) {}
    setUser(false);
    setPerms([]);
  };

  const hasPerm = (p) => perms.includes("*") || perms.includes(p);

  return (
    <AuthContext.Provider value={{ user, perms, ready, login, logout, hasPerm, completeLogin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
